import React from "react";
import { Box } from "@mui/material";

/**
 * Simple SVG pie chart for kid-friendly games.
 * @param {Array<{ name: string, value: number, color: string }>} data - segments
 * @param {number} size - width/height in px
 */
const PieChart = ({ data = [], size = 200 }) => {
    const total = data.reduce((s, d) => s + d.value, 0) || 1;
    const cx = size / 2;
    const cy = size / 2;
    const r = size / 2 - 12;
    let startAngle = -90; // Start at 12 o'clock

    const segments = data.map((segment) => {
        const pct = segment.value / total;
        const sweep = pct * 360;
        const endAngle = startAngle + sweep;
        const x1 = cx + r * Math.cos((startAngle * Math.PI) / 180);
        const y1 = cy + r * Math.sin((startAngle * Math.PI) / 180);
        const x2 = cx + r * Math.cos((endAngle * Math.PI) / 180);
        const y2 = cy + r * Math.sin((endAngle * Math.PI) / 180);
        const large = sweep > 180 ? 1 : 0;
        const d = `M ${cx} ${cy} L ${x1} ${y1} A ${r} ${r} 0 ${large} 1 ${x2} ${y2} Z`;
        startAngle = endAngle;
        return { d, color: segment.color, name: segment.name };
    });

    return (
        <Box
            component="svg"
            viewBox={`0 0 ${size} ${size}`}
            width={size}
            height={size}
            sx={{ display: "block", mx: "auto" }}
            aria-label="Pie chart"
        >
            {segments.map((seg, i) => (
                <path
                    key={i}
                    d={seg.d}
                    fill={seg.color}
                    stroke="#fff"
                    strokeWidth={3}
                />
            ))}
        </Box>
    );
};

export default PieChart;
